import { render } from "./TopbarComponent.vue?vue&type=template&id=78304d3a&scoped=true"
import script from "./TopbarComponent.vue?vue&type=script&lang=js"
export * from "./TopbarComponent.vue?vue&type=script&lang=js"

import "./TopbarComponent.vue?vue&type=style&index=0&id=78304d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78304d3a"]])

export default __exports__